var contentLoaderCache = new Map();
var loadingState = new Map();

class ContentLoader extends HTMLElement {
  constructor() {
    super();
    this.prefetchStrategy = this.getAttribute('prefetch') || 'mount';
  }

  connectedCallback() {
    this.handlePrefetch();
  }

  handlePrefetch() {
    const url = this.getAttribute('url');
    const selector = this.getAttribute('selector');

    if (!url || !selector) {
      console.error('content-loader requires both "url" and "selector" attributes.');
      return;
    }

    if (this.prefetchStrategy === 'mount') {
      this.loadContent();
    } else if (this.prefetchStrategy === 'click') {
      this.addEventListener('click', () => this.loadContent(), { once: true });
    } else if (this.prefetchStrategy === 'when-visible') {
      const observeTargets = document.querySelectorAll(this.getAttribute('observe-target')) || Array.from([this]);
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.loadContent();
            observer.disconnect();
          }
        });
      });
      observeTargets.forEach(observeTarget => observer.observe(observeTarget));
    } else {
      console.error(`Unknown prefetch strategy: ${this.prefetchStrategy}`);
    }
  }

  async loadContent() {
    const url = this.getAttribute('url');
    const selector = this.getAttribute('selector');

    if (contentLoaderCache.has(url)) {
      const cachedContent = contentLoaderCache.get(url);
      const doc = new DOMParser().parseFromString(cachedContent, 'text/html');
      const targetElement = doc.body.querySelector(selector);

      if (targetElement) {
        this.innerHTML = targetElement.outerHTML;
      } else {
        console.error(`Target element not found for selector: ${selector}`);
      }
      return;
    }

    if (loadingState.has(url)) {
      await loadingState.get(url);
      this.loadContent();
      return;
    }

    const loadingPromise = this.fetchAndCacheContent(url, selector);
    loadingState.set(url, loadingPromise);

    await loadingPromise;

    loadingState.delete(url);
  }

  async fetchAndCacheContent(url, selector) {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const content = await response.text();
      contentLoaderCache.set(url, content);

      const parser = new DOMParser();
      const doc = parser.parseFromString(content, 'text/html');
      const targetElement = doc.body.querySelector(selector);

      if (targetElement) {
        this.innerHTML = targetElement.outerHTML;
      } else {
        console.error(`Target element not found for selector: ${selector}`);
      }
    } catch (error) {
      console.error('Error loading content:', error);
    }
  }
}

customElements.define('content-loader', ContentLoader);
